// extracted by mini-css-extract-plugin
module.exports = {"info":"LinkAnotherAppInsideCard_info__2v2rv"};